// advancedDrawingsStore.js — per-user, per-chart-context, per-type multi-point drawing
// persistence (Supabase `chart_advanced_drawings`, migration 0007). Mirrors
// drawingsStore.js exactly, plus a `type` filter/column since this one table serves
// Trend Line (this build) and, in later builds, Parallel Channel / Fib Retracement /
// Long Position — all sharing the same table (see 0007's header comment).
//
// v1 caller: trendLineTool.js, always with type="trendline". `points` is stored as
// {time1, price1, time2, price2} (same field names as measurementsStore.js).
import { supabase } from "./supabaseClient";

// SELECT every saved row for this user + symbol + context + type.
export async function fetchAdvancedDrawings(userId, symbol, context, type) {
  const { data, error } = await supabase
    .from("chart_advanced_drawings")
    .select("id, points, meta")
    .eq("user_id", userId)
    .eq("symbol", symbol)
    .eq("context", context)
    .eq("type", type);
  if (error) throw error;
  return data ?? [];
}

// Insert one new row. Returns the inserted row (need its id for later delete).
export async function insertAdvancedDrawing(userId, symbol, context, type, points, meta = null) {
  const { data, error } = await supabase
    .from("chart_advanced_drawings")
    .insert({ user_id: userId, symbol, context, type, points, meta })
    .select("id, points, meta")
    .single();
  if (error) throw error;
  return data;
}

// Delete one row by id (RLS still scopes this to the caller's own rows).
export async function deleteAdvancedDrawing(userId, drawingId) {
  const { error } = await supabase
    .from("chart_advanced_drawings")
    .delete()
    .eq("user_id", userId)
    .eq("id", drawingId);
  if (error) throw error;
}
